/**
 * Created by olga on 26.12.2024
 */

const BoardTutorial = function () {
    return new TutorialScenario(TutorialScenario.BASIC_TUTORIAL_NAME, {
        listSteps: BoardTutorial.listSteps,

        onStart: function () {
            this.highlightedLettersElements = [];
            Game.currentGame.keypad.hideShuffleButton();
        },

        onFinish: function () {
            delete this.highlightedLettersElements;
            Game.currentGame.keypad.showShuffleButton();
        },

        isAvailable: function () {
            const game = Game.currentGame;

            if (!game) {
                return false;
            }
            
            return game.introPlaying ? game.levelWithTutorial() && BoardTutorialHelper.listTutorialWords(2).length
                : cleverapps.isKnockoutGame() && !cleverapps.forces.isShown(Forces.KEYPAD);
        }
    });
};

BoardTutorial.listSteps = function () {
    const steps = [];

    BoardTutorialHelper.listTutorialWords(3).forEach((word, index) => {
        const options = {};
        options.word = word;
        options.pathColor = cleverapps.styles.COLORS.PATH_COLOR;

        const sceneComponent = cleverapps.Scenes.GetSceneComponent(WordGameSceneComponent);

        const highlightedLettersElements = cleverapps.tutorial.getActive().highlightedLettersElements;

        Game.currentGame.board.listWordIndexes(word).forEach((indexes) => {
            highlightedLettersElements.push(sceneComponent.boardView.grid.getCell(indexes[0], indexes[1]));
            highlightedLettersElements.push(sceneComponent.boardView.grid.getCell(indexes[0], indexes[1], cleverapps.Board.LETTER_LAYER));
        });

        options.highlights = highlightedLettersElements;

        if (index === 0 && !cleverapps.forces.isShown(Forces.KEYPAD)) {
            options.force = Forces.KEYPAD;

            if (Game.currentGame.board.gridType === "crossword") {
                options.force.position = { x: { align: "right" }, y: { align: "center", dy: 90 } };
            } else {
                options.importantNodes = highlightedLettersElements.concat(sceneComponent.currentView);
            }
        }

        steps.push(BoardTutorialHelper.getDiscoverWordStep(options));
    });

    return steps;
};
